import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { useMessage } from '../../components/Message';
import UserModal from './UserModal';

const UsersTab = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const { showMessage } = useMessage();

    const fetchUsers = async () => {
        try {
            setLoading(true);
            const res = await api.get('/admin/users');
            setUsers(res.data.data || []);
        } catch (err) {
            showMessage(err.response?.data?.message || 'Failed to load users', 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleEdit = (user) => {
        setSelectedUser(user);
        setShowModal(true);
    };

    const handleSave = async (updated) => {
        try {
            await api.put(`/admin/users/${updated.id}`, updated);
            showMessage('User updated', 'success');
            setShowModal(false);
            fetchUsers();
        } catch (err) {
            showMessage(err.response?.data?.message || 'Failed to update', 'error');
        }
    };

    const handleDelete = async (userId) => {
        if (!window.confirm('Are you sure you want to delete this user? This action cannot be undone.')) {
            return;
        }
        try {
            await api.delete(`/admin/users/${userId}`);
            showMessage('User deleted', 'success');
            fetchUsers();
        } catch (err) {
            showMessage(err.response?.data?.message || 'Failed to delete', 'error');
        }
    };

    return (
        <div className="admin-users-tab">
            <div className="admin-tab-header">
                <h2 className="admin-tab-title">All Users</h2>
            </div>
            {loading ? (
                <p className="admin-loading-state">Loading...</p>
            ) : (
                <div className="admin-table-wrapper">
                    <table className="admin-data-table admin-users-table">
                        <thead>
                            <tr>
                                <th>Username</th>
                                <th>Email</th>
                                <th>Role</th>
                                <th>Verified</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map(u => (
                                <tr key={u.id} className="admin-table-row">
                                    <td className="admin-table-cell">{u.username}</td>
                                    <td className="admin-table-cell">{u.email}</td>
                                    <td className="admin-table-cell">{u.role}</td>
                                    <td className="admin-table-cell">{u.isVerified ? 'Yes' : 'No'}</td>
                                    <td className="admin-table-cell admin-actions-cell">
                                        <button className="admin-btn-edit" onClick={() => handleEdit(u)}>Edit</button>
                                        <button className="admin-btn-delete" onClick={() => handleDelete(u.id)}>Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {showModal && selectedUser && (
                <UserModal 
                    user={selectedUser}
                    onClose={() => setShowModal(false)}
                    onSave={handleSave}
                />
            )}
        </div>
    );
};

export default UsersTab;